export default "__VITE_ASSET__BvD6Mtx___"